import { createAsyncThunk } from '@reduxjs/toolkit';
import { firestore } from '../../firebase';

export const fetchFiles = createAsyncThunk('files/fetchFiles', async () => {
  try {
    const filesRef = firestore.collection('files');
    const snapshot = await filesRef.get();
    const files = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    return files;
  } catch (error) {
    console.error('Error fetching files:', error);
    throw error;
  }
});


export const addFile = createAsyncThunk('files/addFile', async (fileData) => {
  console.log("addFile");
  console.log(fileData);
  try {
    const filesRef = firestore.collection('files');
    const newFileRef = await filesRef.add(fileData);

    const fileId = newFileRef.id;
    const newFile = { id: fileId, ...fileData };

    return newFile;
  } catch (error) {
    console.error('Error adding file:', error);
    throw error;
  }
});


export const removeFile = createAsyncThunk('files/removeFile', async (fileId) => {
  try {
    const filesRef = firestore.collection('files');
    await filesRef.doc(fileId).delete();
    return fileId; 
  } catch (error) {
    console.error('Error removing file:', error);
    throw error;
  }
});